

export const ControlList=[
    {
        label:"Add user",
        value:"add_user",
        checked:true
    },
    {
        label:"Add employee",
        value:"add_employee",
        checked:true
    },
    {
        label:"Edit user",
        value:"edit_user",
        checked:false
    }
]
export const profileData=[
    {
        label:"First Name",
        value:"firstname",
        type:"text",
        data:"Tarakeswar"
    },
    {
        label:"Last Name",
        value:"lastname",
        type:"text",
        data:"Mondal"
    },
    {
        label:"email",
        value:"email",
        type:"email",
        data:"abc@gmail.com"
    },
    {
        label:"mobile",
        value:"mobile",
        type:"number",
        data:'9185858588'
    },
    {
        label:"address",
        value:"address",
        type:"textarea",
        data:"Beldanga andiron"
    },
    {
        label:"password",
        value:"password",
        type:"text",
        data:""
    }
]